import enableInlineVideo from "iphone-inline-video"

import Reg from "./reg"

export function getPlatform(): "h5" | "pc" | "ipad" {
    const ua = navigator.userAgent
    if (Reg.isiPad.test(ua)) {
        return "ipad"
    } else if (!Reg.isMobile.test(ua)) {
        // Not Mobile
    } else if (Reg.isiOS.test(ua) || Reg.isAndroid.test(ua)) {
        // iOS Android
        return "h5"
    }
    return "pc"
}

export function isVivoBrowser() {
    const userAgent = navigator.userAgent
    return Reg.isVivoBrowser.test(userAgent)
}

export function isMiuiBrowser() {
    const userAgent = navigator.userAgent
    return Reg.isMiuiBrowser.test(userAgent)
}

export function isMobile(): boolean {
    return typeof document.body.ontouchstart !== "undefined"
}

export function formatDuration(seconds: number) {
    const hours = Math.floor(seconds / 3600)
    const minutes = Math.floor((seconds - hours * 3600) / 60)
    const sec = seconds - hours * 3600 - minutes * 60

    return `${String(hours).padStart(2, "0")}:${String(minutes).padStart(
        2,
        "0"
    )}:${String(sec).padStart(2, "0")}`
}

export function formatDateTime(ts: number) {
    const date = new Date(ts * 1000)

    const year = date.getFullYear()
    const month = String(date.getMonth() + 1).padStart(2, "0")
    const day = String(date.getDate()).padStart(2, "0")

    const hour = String(date.getHours()).padStart(2, "0")
    const minute = String(date.getMinutes()).padStart(2, "0")
    const second = String(date.getSeconds()).padStart(2, "0")

    return `${year}/${month}/${day} ${hour}:${minute}:${second}`
}

let _innerWidth = 0
let _innerHeight = 0

let _fontSize = 16
let _width = 0,
    _height = 0

export function handleResize(baseFontSize = 16) {
    const { innerWidth, innerHeight } = window

    const width = Math.max(innerWidth, innerHeight)
    const height = Math.min(innerWidth, innerHeight)

    _width = width
    _height = height

    if (innerWidth === _innerWidth && innerHeight === _innerHeight) {
        return
    } else {
        _innerWidth = innerWidth
        _innerHeight = innerHeight
    }

    // lock orientation
    if (innerWidth < innerHeight) {
        document.body.style.cssText = `
            position: relative;
            left: ${height}px;
            width: ${width}px;
            height: ${height}px;
            transform-origin: top left;
            transform: rotate(90deg);
        `
        document.body.dataset.rotate = "1"
    } else {
        document.body.style.cssText = `
            width: ${width}px;
            height: ${height}px;
        `
        document.body.dataset.rotate = "0"
    }

    let fontSize = baseFontSize

    if (width / height > 16 / 9) {
        fontSize *= height / 1080
    } else {
        fontSize *= width / 1920
    }

    // set root font size
    const html = document.querySelector("html") as HTMLElement
    html.style.fontSize = `${fontSize}px`
    _fontSize = fontSize

    // font size should be scaled if system font setting is enabled
    const realFontSize = Number(
        window.getComputedStyle(html)["font-size"].replace("px", "")
    )
    if (realFontSize !== fontSize) {
        html.style.fontSize = `${(fontSize * fontSize) / realFontSize}px`
        _fontSize = (fontSize * fontSize) / realFontSize
    }

    // callback?.()

    // window.requestAnimationFrame(() => {
    //     handleResize(baseFontSize, callback)
    // })
}

const designWidth = 1920
const designHeight = 1080

export function handleResizeBySize(
    width: number,
    height: number,
    baseFontSize = 16
) {
    let fontSize = baseFontSize

    if (width / height > designWidth / designHeight) {
        fontSize *= height / designHeight
    } else {
        fontSize *= width / designWidth
    }

    // set root font size
    const html = document.querySelector("html") as HTMLElement
    html.style.fontSize = `${fontSize}px`
    _fontSize = fontSize

    const { userAgent } = window.navigator
    if (userAgent.includes("HarmonyOS") || userAgent.includes("MQQBrowser")) {
        return _fontSize
    }

    // font size should be scaled if system font setting is enabled
    const realFontSize = Number(
        window.getComputedStyle(html)["font-size"].replace("px", "")
    )
    if (realFontSize !== fontSize) {
        _fontSize = (fontSize * fontSize) / realFontSize
        html.style.fontSize = `${_fontSize}px`
    }

    return _fontSize
}

export function getPageSize() {
    return {
        width: _width,
        height: _height,
    }
}

export function getFontSize() {
    return _fontSize
}

export const loadImage = (url: string) => {
    return new Promise<HTMLImageElement>((resolve, reject) => {
        const img = new Image()
        img.crossOrigin = "anonymous"
        img.onload = () => resolve(img)
        img.onerror = reject
        img.src = url
    })
}

export const inlineVideo = (video: HTMLVideoElement) => {
    if (window.navigator.userAgent.includes("weibo")) {
        enableInlineVideo(video)
    }
}
